DetailOutput = App.loadClass 'core::reports/DetailOutput'
BaseOutput = App.loadClass 'core::reports/BaseOutput'
BaseHandler = App.loadClass 'core::reports/BaseHandler'

class exports.Reports_CropReadiness_SubHandler extends BaseHandler
    init: () ->
        @hasPrint       = true
        @filterUrl      = 'backend/portal/reports/crop-readiness/filters'
        @excelUrl       = 'backend/portal/reports/crop-readiness/excel'
        @layoutSelector = '#reports_crop_readiness_tab'

        @parent.dialog.find('.excel-btn').removeClass('hidden')
        @initFilters()

    initFilters: () ->
        @resetFilters()
        @parent.filters.importGroup
            name: 'Crop Readiness Filters'
            filters: [
                name: 'field_ids'
                display_name: 'Cargill ID'
                class: 'dropup'
            ,
                name: 'seed_company'
                display_name: 'Seed Company'
                class: 'dropup'
            ,
                name: 'brands'
                display_name: 'Brand'
                class: 'dropup'
            ,
                name: 'planting_date'
                display_name: 'Planting Date'
                control_type: 'datepicker'
            ,
                name: 'output_type'
                display_name: 'Output Type'
                control_type: 'option'
                deletable: false
                values: [
                    { key: 'detail', value: 'Detail' },
                    { key: 'summary', value: 'Summary' }
                ],
                selected_values: [
                    { key: 'detail', value: 'Detail' }
                ],
            ]

        @setDefaultsAndRun()

    destroy: () ->
        @parent.filters.removeGroup 'Crop Readiness Filters'
        super()
        $(@layoutSelector).empty()

    beforeApply: () ->
        filters = @parent.filters.jsonize()

        if filters.filters.output_type[0].key is 'detail'
            @layoutUrl  = 'backend/portal/reports/crop-readiness/table/detail'
            @printUrl   = 'backend/portal/reports/crop-readiness/print/detail'
            @currentOutput = new DetailOutput this, @parent, 'auto', { sAjaxSource: 'backend/portal/reports/crop-readiness/output/detail' }
        else
            @layoutUrl  = 'backend/portal/reports/crop-readiness/output/summary'
            @printUrl   = 'backend/portal/reports/crop-readiness/print/summary'
            @currentOutput = new BaseOutput this, @parent
